import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import data from "../preloaded/deuda.json";
import { getName } from "country-list";
import { useTranslation } from "react-i18next";

export const DebtScamChart = () => {
  const { t } = useTranslation();


  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip bg-white border border-gray-300 rounded py-2 px-4">
          <p className="label text-blue-700">{getName(label)}</p>
          <p className="intro text-gray-800">{`Total: USD $${payload[0].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}`}</p>
          <p className="desc text-gray-800">{`${t('scammed_people')}: ${payload[0].payload.total_people_scammed}`}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="flex justify-center items-center bg-gray-100">
      <div className="w-full bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-bold text-center mb-4">{t('account_registered')}</h2>

        <p>{t('account_debt_info')}</p>

        <div className="w-full h-96">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 20, right: 30, left: 80, bottom: 5 }}>
              <XAxis dataKey="country_code" type="category" />
              <YAxis
                type="number"
                tickFormatter={(value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)}
              />

              <Tooltip content={<CustomTooltip />} />
              <Legend />
              <Bar dataKey="total_balance_by_country" fill="#1D4ED8" name={t('total_debt')} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};